import BulletinsIcon from 'assets/images/menu/bulletins.svg';
import BiddingOnlineSearchIcon from 'assets/images/menu/bidding-online-search.svg';
import FollowupOnlineSearchIcon from 'assets/images/menu/followup-online-search.svg';
import ManagementIcon from 'assets/images/menu/management.svg';
import DocumentsIcon from 'assets/images/menu/documents.svg';
import MonitoringIcon from 'assets/images/menu/monitoring.svg';
import DigitalSignatureIcon from 'assets/images/menu/digital-signature.svg';
import ImminenceIcon from 'assets/images/menu/imminence.svg';
import RobotIcon from 'assets/images/menu/robot.svg';
import DashboardIcon from 'assets/images/menu/dashboard.svg';
import NewMovements from 'assets/images/painel_new/new_movements.svg';
import DelayedDocument from 'assets/images/painel_new/delayed_document.svg';
import PendingDocument from 'assets/images/painel_new/pending_document.svg';
import cadastralAdvisory from 'assets/images/panel/cadastral-advice.svg';
import exclusiveContent from 'assets/images/panel/jobs.svg';
import contractsImg from 'assets/images/panel/contracts.svg';
import sendYourDoubtImg from 'assets/images/panel/questions.svg';
import toolsStatusImg from 'assets/images/panel/status.svg';
import legalArticlesImg from 'assets/images/panel/legal-articles.svg';
import inCompanyCourses from 'assets/images/panel/in-company-courses.svg';
import apiConlicitacao from 'assets/images/panel/api.svg';
import conlicitaGoImg from 'assets/images/panel/conlicitago.svg';
import clippingPolice from 'assets/images/panel/clipping.svg';
import AtaRegistroPrecoImg from 'assets/images/panel/price-registration-minutes.svg';
import marketAnalysisImg from 'assets/images/panel/market-analysis.svg';
import MyHistory from 'assets/images/panel/historic.svg';
import concurrentImg from 'assets/images/panel/concurrent.svg';
import managementPortals from 'assets/images/panel/management-portals.svg';
import drLicita from 'assets/images/panel/drlicita.svg';
import iconConlicitaseg from 'assets/images/panel/conlicitaseg.svg';
import iconIA from 'assets/images/icone-ia.svg';
import resumoEdital from 'assets/images/resumo-edital.svg';
import pergunteAoEdital from 'assets/images/pergunte-ao-edital.svg';
import analyzeContract from 'assets/images/analyze_contract.svg';
import centralAi from 'assets/images/panel/central_ia.svg';
import conlicitacaoAcademy from 'assets/images/menu/conlicita-academy.svg';
import priceIntelligence from 'assets/images/panel/price-intelligence.svg';
import suppliersImg from 'assets/images/panel/suppliers.svg';
import customerProspectingImg from 'assets/images/panel/customer-prospecting.svg';
import myClientsImg from 'assets/images/panel/my-clients.svg';
import kanbanImg from 'assets/images/panel/kanban.svg';

export const featureIcon = (iconName: string) => {
  switch (iconName) {
    case 'bulletins':
      return BulletinsIcon;
    case 'search':
      return BiddingOnlineSearchIcon;
    case 'assignment':
      return FollowupOnlineSearchIcon;
    case 'assessment':
      return ImminenceIcon;
    case 'star':
      return ManagementIcon;
    case 'folder':
      return DocumentsIcon;
    case 'robot':
      return RobotIcon;
    case 'chat':
      return MonitoringIcon;
    case 'digital_signature':
      return DigitalSignatureIcon;
    case 'new_movements':
      return NewMovements;
    case 'delayed_document':
      return DelayedDocument;
    case 'pending_document':
      return PendingDocument;
    case 'contact_support':
      return cadastralAdvisory;
    case 'work':
      return exclusiveContent;
    case 'gavel':
      return contractsImg;
    case 'help_outline':
      return sendYourDoubtImg;
    case 'settings':
      return toolsStatusImg;
    case 'article':
      return legalArticlesImg;
    case 'group':
      return inCompanyCourses;
    case 'code':
      return apiConlicitacao;
    case 'school':
      return conlicitaGoImg;
    case 'local_police':
      return clippingPolice;
    case 'receipt':
      return AtaRegistroPrecoImg;
    case 'bar_chart':
      return marketAnalysisImg;
    case 'history':
      return MyHistory;
    case 'concurrent':
      return concurrentImg;
    case 'manage_portals':
      return managementPortals;
    case 'dr_licita':
      return drLicita;
    case 'conlicitaseg':
      return iconConlicitaseg;
    case 'ia':
      return iconIA;
    case 'resumo_edital':
      return resumoEdital;
    case 'pergunte_ao_edital':
      return pergunteAoEdital;
    case 'analyze_contract':
      return analyzeContract;
    case 'central_ia':
      return centralAi;
    case 'conlicitacao_academy':
      return conlicitacaoAcademy;
    case 'price_intelligence':
      return priceIntelligence;
    case 'fornecedores':
      return suppliersImg;
    case 'prospeccao_clientes':
      return customerProspectingImg;
    case 'meus_clientes':
      return myClientsImg;
    case 'kanban':
      return kanbanImg;
    default:
      return DashboardIcon;
  }
};

const COLORED_ICONS = ['central_ia', 'analyze_contract', 'conlicitaseg'];

export const isColoredIcon = (icon: string): boolean => COLORED_ICONS.includes(icon);
